import script from "./HomeNav.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeNav.vue?vue&type=script&setup=true&lang=js"

import "./HomeNav.vue?vue&type=style&index=0&id=3cf833f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf833f0"]])

export default __exports__